import React from "react";
import { ReactSVG } from "react-svg";

const SSCItem = ({ title, svgUrl, desc }) => {
  return (
    <div className="w-[280px] h-[400px] bg-zinc-100 border-4 border-white rounded-xs my-8 py-10 md:mx-0 mx-auto">
      <center>
        <ReactSVG src={svgUrl} className="h-20" />
      </center>

      <div className="px-8 pt-8">
        <h1 className="text-lg text-black font-medium text-left mb-2">
          {title}
        </h1>
        <p className="text-sm text-black font-light text-left">{desc}</p>
      </div>
      {/* <div className="flex justify-center mt-1 mb-6">
        <button
          style={{ background: "rgba(41, 53, 134, 0.17)", color: "#293586" }}
          className="py-2 px-10 font-medium rounded-sm shadow-sm"
        >
          Read More
        </button>
      </div> */}
    </div>
  );
};

export default SSCItem;
